import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import * as Sentry from '@sentry/react';
import * as Integrations from '@sentry/integrations';
import { isDev } from './CommonUtils/IsDev';
import { versionNumber } from './CommonUtils/Version';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

Sentry.init({
    dsn: 'https://99bea274eda94405a9b0b5d72a3cf893@o76416.ingest.sentry.io/6542040',
    integrations: [
        // send an event to sentry whenever an error is logged in the console
        new Integrations.CaptureConsole({ levels: ['error'] }),
        // send an event to sentry when an error or an unhandled webservice rejection occurs
        new Sentry.Integrations.GlobalHandlers({ onerror: true,
            onunhandledrejection: true }),
        // Used in conjunction with normalizeDepth to allow objects in the 'extra' field to have a depth of 10
        new Integrations.ExtraErrorData({ depth: 10 }),
    ],
    // limits all objects sent in an error event to a depth of 10
    normalizeDepth: 10,
    attachStacktrace: true,
    beforeSend: (event: Sentry.Event, hint: Sentry.EventHint) => {
        if (isDev || [
            'Error: Connection disconnected with error',
        ].some((m) => event.message?.includes(m))) {
            return null;
        }

        return event;
    },
    environment: process.env.REACT_APP_ENVIRONMENT?.toLowerCase(),
});

Sentry.configureScope((scope) => {
    scope.setTags({
        version: versionNumber(),
        application: process.env.REACT_APP_TYPE === 'SUPPORT' ? 'Support' : 'Dashboard',
    });
});

/**
 * Update the theme class name for use with the themify function
 * so environment specific styles will be used.
 */
document.body.classList.add(`theme-${process.env.REACT_APP_ENVIRONMENT}`);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

const router = createBrowserRouter([
    {
        path: '/*',
        element: <App />,
    },
]);

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);
